import { useForm } from "react-hook-form";
import React, { useEffect, useContext } from 'react';
import GeneralModal from '../../helpers/GeneralModal';
import { createModal } from 'react-modal-promise';
import LogicContext from '../../Context/LogicContext';
import { bankingService } from "../../services/bankingService";
import { useNavigate } from 'react-router-dom';
import { GetBankingList, SetBankingList } from "../../store/bankingAtom";



export default function AddBankingPage({ initialData, accountTypes }) {
  const logicContext = useContext(LogicContext);
  const myPromiseModal = createModal(GeneralModal);
  const navigate = useNavigate();
    const getBankingData  = GetBankingList();
  


  const { register, handleSubmit, getValues, setValue,reset, formState: { errors } } = useForm({
    defaultValues: {
      Account_Name: "",
      Account_Description: "",
      Currency_Id: "",
      Account_Type_Id: "",
      Account_Number: "",
    },
  });

  useEffect(() => {
    
    if (initialData) {
      reset(initialData);
    }
  }, [initialData, reset]);



  const submitData = async (data) => {
    setValue('Account_Type_Id', 1);
    let formData = getValues();
    let option =  1;
    const response = await myPromiseModal({
      title: 'Confirmation',
      body: 'Do you want to save this record?',
      showInput: false,
      placeHolder: '',
    });
    if (response.decision === false) {
        return;
    }

    // onSubmit && onSubmit(data);
    bankingService.submitBanking({...formData, option}).then((res)=> {
        // if (response?.data) {
          try {
            const cleanResponse = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
            const { message_id, message_text } = cleanResponse;
            if (message_id === 1) {
              logicContext.showToast(message_text, 'success');
              sessionStorage.setItem('reloadPage', 'true');
              navigate(-1);
            } else {
              return logicContext.showToast(message_text, 'error');
            }
            
          } catch (error) {
            console.log("error ", error);
            
            
          }
        //   }

    });

  };

  return (
    // Full viewport height & width, centered content
    <div className="min-h-screen w-full bg-gray-50 flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-xl border border-gray-200 p-8 md:p-10">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-8 text-center">
          {initialData ? 'Edit' : 'Add'} Bank Account
        </h2>

        <form onSubmit={handleSubmit(submitData)} className="space-y-6">
          {/* Account Name */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Account Name</label>
            <input
              type="text"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
              {...register("Account_Name", { required: "Account name is required" })}
            />
            {errors.Account_Name && <p className="mt-1 text-sm text-red-600">{errors.Account_Name.message}</p>}
          </div>

          {/* Account Description */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Account Description</label>
            <input
              type="text"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
              {...register("Account_Description", { required: "Description is required" })}
            />
            {errors.Account_Description && <p className="mt-1 text-sm text-red-600">{errors.Account_Description.message}</p>}
          </div>

          {/* Currency */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Currency</label>
            <select
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
              {...register("Currency_Id", { required: "Currency is required" })}
            >
              <option value="">Select Currency</option>
              {getBankingData?.currency_info?.map((c) => (
                <option key={c.currency_id} value={c.currency_id}>{c.currency_name}-{c.currency_name_short} </option>
              ))}
            </select>
            {errors.Currency_Id && <p className="mt-1 text-sm text-red-600">{errors.Currency_Id.message}</p>}
          </div>

          {/* Account Type */}
          {/* <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Account Type</label>
            <select
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
              {...register("Account_Type_Id", { required: "Account type is required" })}
            >
              <option value="">Select Account Type</option>
              {accountTypes?.map((t) => (
                <option key={t.id} value={t.id}>{t.name}</option>
              ))}
            </select>
            {errors.Account_Type_Id && <p className="mt-1 text-sm text-red-600">{errors.Account_Type_Id.message}</p>}
          </div> */}

          {/* Account Number */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Account Number</label>
            <input
              type="text"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
              {...register("Account_Number", { required: "Account number is required" })}
            />
            {errors.Account_Number && <p className="mt-1 text-sm text-red-600">{errors.Account_Number.message}</p>}
          </div>

          <button
            type="submit"
            className="w-full bg-blue-600 text-white font-semibold py-4 rounded-lg hover:bg-blue-700 transform hover:scale-105 transition duration-200 shadow-md"
          >
            Save Account
          </button>
        </form>
      </div>
    </div>
  );
}